import { Factory } from '@mui/icons-material'
import React from 'react'
import { Box, Button, Card, CardActions, CardContent, Paper, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import Grid from '@mui/material/Unstable_Grid2'

const SolarEngineeringLandingPage: React.FC = () => {
  const history = useHistory()
  const goTo = (location: string): void => {
    history.push(location)
  }

  return (
    <>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Solar Engineering Team</Typography>
      </Box>
      <Paper>
        <Box sx={{ p: 4 }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid xs={6}>
              <Card sx={{ mr: 4 }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Solar Plants
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  <Button startIcon={<Factory/>} color="primary" onClick={() => { goTo('/app/solar-engineering/solar-plants') }}>
                    Solar Plants
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid xs={6}>
              <Card sx={{ mr: 4 }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Meta data
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  <Button startIcon={<Factory/>} color="primary" onClick={() => { goTo('/app/solar-engineering/monitoring-metrics') }}>
                    Monitoring Metrics
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  )
}

export default SolarEngineeringLandingPage
